export const ROLLOUTS_BASE_URL = '/rollouts';
